const DisclaimerIcon = () => {
    return (
        <svg
            id="Group_8365"
            data-name="Group 8365"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 20 22.983"
        >
            <g id="Group_8363" data-name="Group 8363" transform="translate(0 0)">
                <path
                    id="Path_3576"
                    data-name="Path 3576"
                    d="M7.437,24.474a.411.411,0,0,1,.411-.411H19.365a.411.411,0,0,1,0,.823H7.848a.411.411,0,0,1-.411-.411"
                    transform="translate(-1.319 -4.268)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3577"
                    data-name="Path 3577"
                    d="M1.437,17.474a.411.411,0,0,1,.411-.411H4.728a.411.411,0,0,1,0,.823H1.848a.411.411,0,0,1-.411-.411"
                    transform="translate(-0.255 -3.026)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3578"
                    data-name="Path 3578"
                    d="M2.859.375V1.541a1.432,1.432,0,0,1-1.42,1.444H.375M2.859.375H13.865a1.432,1.432,0,0,1,1.42,1.445M2.859.375.375,2.984m0,0V19.806a1.432,1.432,0,0,0,1.42,1.445H4.848M7.333,1.866V3.031a1.432,1.432,0,0,1-1.42,1.445H4.848M7.333,1.866H18.338a1.432,1.432,0,0,1,1.42,1.445V21.3a1.432,1.432,0,0,1-1.42,1.445H6.268A1.432,1.432,0,0,1,4.848,21.3V4.476M7.333,1.866,4.848,4.476M8.842,15.815l-.885,2.1m.885-2.1,6.468-6.468M8.842,15.815l1.779,1.779m-2.664.324-.1.239a.323.323,0,0,0,.424.423l.239-.1m-.562-.561.562.561m2.1-.885-2.1.885m2.1-.885,6.468-6.468M15.309,9.348,15.66,9a.645.645,0,0,1,.915,0l.864.864a.647.647,0,0,1,0,.915l-.351.35M15.309,9.348l1.779,1.779M6.339,14.54c.745-1.118,2.609-1.863,1.491,3.727"
                    transform="translate(-0.067 -0.067)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="0.75"
                />
            </g>
        </svg>
    );
};

export default DisclaimerIcon;
